import React from 'react';
import Header from '../../components/ui/Header';
import Seo from '../../components/Seo';
import { FAQ_CLUSTERS, getFaqPageSchema } from '../../content/faqs';

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ | Neevii"
        description="Frequently asked questions about Neevii — AI-powered accounting software for UK small businesses."
        schema={getFaqPageSchema()}
      />
      <div className="min-h-screen">
        <Header />
        <main className="pt-24 pb-16 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-4">Frequently Asked Questions</h1>
            <p className="text-muted-foreground mb-10">
              Clear, factual answers designed to be easy for both people and machines to understand.
            </p>

            <div className="space-y-12">
              {FAQ_CLUSTERS.map((cluster) => (
                <section key={cluster.id} className="space-y-5">
                  <h2 className="text-2xl font-bold text-foreground">{cluster.title}</h2>
                  <div className="space-y-6">
                    {cluster.items.map((f) => (
                      <section
                        key={`${cluster.id}:${f.question}`}
                        className="bg-card/40 backdrop-blur-sm border border-border rounded-2xl p-6"
                      >
                        <h3 className="text-xl font-semibold text-foreground">{f.question}</h3>
                        <p className="text-muted-foreground mt-2">{f.answer}</p>
                      </section>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

